import * as React from "react"
import styled from 'styled-components'

const DivStyled = styled.div`

&.box-white{
    padding: 1rem;
    background: #fff;
    width: 100%;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    position: relative;


    .title{
        font-size: 1.5em;
        font-weight: bold;

        :after{
            content: "";
            position: absolute;
            bottom: -2px;
            top: inherit;
            left: 50%;
            height: 1px;
            transform: translateX(-50%);
            background-color: rgb(31, 191, 217);
            width: 130%;
        }
    }

    //Final Report SCSS

    p{
        text-align: center;
        margin: 1rem 0;
    }
    .info{
        padding: 1rem 0px;
    }

    .exercise-dialogue-text{
        p{
            text-align: justify;
        }
    }

    .text{
        color: #505050;
        line-height: 1.5rem;
        text-align: center;
    }

    .report-title {
        text-align: center;
        padding-bottom: 1rem;
        margin-left: -1rem;
        border-bottom: 2px solid;
    }

    .test-name{
        font-size: 1rem;
    }

    .report-actions {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }
`

export default (node: any) => {
    return <DivStyled className="box-white">
        {node.children}
    </DivStyled>
}